// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__deovt","col":"styles_col__3uh2l"};